import { Flex, Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';
import { FC, memo, useId, useMemo } from 'react';
import { ChevronDoubleRight } from 'react-bootstrap-icons';

interface Props extends TextProps {
  path: string;
}

export const AwesomeNodePath: FC<Props> = memo(({ path, ...props }) => {
  const keyPrefix = useId();

  const beautifyNodePath = useMemo((): string[] => {
    return path
      .replace(/^\/|\/+/g, (match, index) => (index === 0 ? match : '>'))
      .replaceAll('/', '/>')
      .replaceAll(/>$/g, '')
      .split(/(>)/gim);
  }, [path]);

  return (
    <Typography.Text
      { ...props }
      className={ `awesome-node-path ${ props.className }` }
      type={ props?.type ?? 'secondary' }
      style={{ ...props.style, whiteSpace: 'nowrap' }}
    >
      <Flex align="center" justify="flex-start" gap={ 4 } wrap>
        { beautifyNodePath.map((pathEl, index) => {
          if (pathEl === '>') return <ChevronDoubleRight key={ `${ keyPrefix }-${ index }` } size={ 10 }/>;
          return <span key={ `${ keyPrefix }-${ index }` }>{ pathEl }</span>;
        }) }
      </Flex>
    </Typography.Text>
  );
});
